import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { Segment, Table, Statistic } from 'semantic-ui-react'
import HasuraOrderActions from '../../reducers/hasuraOrderReducer'

import DateRangeField from './components/DateRangeField'
import utils from '../../utils'


class PromotionExpense extends React.PureComponent {
  state = {
    startFrom: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    endAt: Number(
      moment()
        .endOf('day')
        .format('x')
    ),
  }

  getOrderByDate = () => {
    const { getPromotionExpense } = this.props
    const { startFrom, endAt } = this.state

    getPromotionExpense(startFrom, endAt)
  }

  onFieldChange = (field, value) => {
    this.setState({ [field]: value })
  }

  validateSearchByDate = () => {
    const { startFrom, endAt } = this.state

    if (startFrom > endAt) {
      return false
    }

    return true
  }

  onSearch = () => {
    const validDate = this.validateSearchByDate()

    if (validDate) {
      this.getOrderByDate()
    } else {
      alert('Date invalid, please check it again')
    }
  }

  renderNoDataRow = () => {
    return (
      <Table.Row>
        <Table.Cell colSpan={7} textAlign="center">
          No Data available
        </Table.Cell>
      </Table.Row>
    )
  }

  renderStatistics = promotionExepense => {
    const orderStats = [
      {
        key: 'orders',
        label: 'Orders',
        value: promotionExepense.orderCount || 0,
      },
      {
        key: 'subtotal',
        label: 'Sub-Total',
        value: utils.helpers.convertToCurrency(promotionExepense.subtotal || 0),
      },
      {
        key: 'commission',
        label: 'Commission',
        value: utils.helpers.convertToCurrency(promotionExepense.commission || 0),
      }
    ]

    const promotionStats = [
      {
        key: 'promotion',
        label: 'Promotion Discount',
        value: utils.helpers.convertToCurrency(promotionExepense.promotionDiscount || 0),
      },
      {
        key: 'merchant-expense',
        label: 'Merchant Expense',
        value: utils.helpers.convertToCurrency(promotionExepense.merchantExpense || 0),
      },
      {
        key: 'company-expense',
        label: 'Company Expense',
        value: utils.helpers.convertToCurrency(promotionExepense.companyExpense || 0),
      },
    ]

    return (
      <div style={{ margin: '14px 0' }}>
        <Segment>
          <Statistic.Group items={orderStats} widths="three" size="small" />
        </Segment>
        <Segment>
          <Statistic.Group items={promotionStats} widths="three" size="small" />
        </Segment>
      </div>
    )
  }

  renderRow = (merchantName, branchKey, branch) => {
    return (
      <Table.Row key={branchKey}>
        <Table.Cell textAlign="center">{merchantName}</Table.Cell>
        <Table.Cell textAlign="center">{branch.name}</Table.Cell>
        <Table.Cell textAlign="center">{utils.helpers.convertToCurrency(branch.subtotal)}</Table.Cell>
        <Table.Cell textAlign="center">{utils.helpers.convertToCurrency(branch.commission)}</Table.Cell>
        <Table.Cell textAlign="center">{utils.helpers.convertToCurrency(branch.promotionDiscount)}</Table.Cell>
        <Table.Cell textAlign="center">{utils.helpers.convertToCurrency(branch.merchantExpense)}</Table.Cell>
        <Table.Cell textAlign="center">{utils.helpers.convertToCurrency(branch.companyExpense)}</Table.Cell>
      </Table.Row>
    )
  }

  render() {
    const { startFrom, endAt } = this.state
    const { loading, promotionExpense } = this.props
    const promotionMerchants = Object.values(promotionExpense ? promotionExpense.merchants : {})

    return (
      <Segment style={{ height: '100%', overflow: 'auto' }}>
        <div style={{ padding: '0px 14px' }}>
          <DateRangeField
            loading={loading}
            startFrom={startFrom}
            endAt={endAt}
            onSearch={this.onSearch}
            onFieldChange={this.onFieldChange}
          />

          {this.renderStatistics(promotionExpense || {})}

          <Table columns={7}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell textAlign="center">Merchant</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Branch</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Subtotal</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Commission</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Promotion Discount</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Merchant Expense</Table.HeaderCell>
                <Table.HeaderCell textAlign="center">Company Expense</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                promotionMerchants.length > 0 ?
                  Object.values(promotionExpense.merchants).map(merchant =>
                    Object.entries(merchant.branches).map(([branchKey, branch]) => this.renderRow(merchant.name, branchKey, branch))
                  ) : this.renderNoDataRow()
              }
            </Table.Body>
          </Table>
        </div>
      </Segment>
    )
  }
}

const mapState = ({ hasuraOrders }) => ({
  promotionExpense: hasuraOrders.promotionExpense,
  loading: hasuraOrders.promotionExpenseLoading,
})

const mapDispatch = {
  getPromotionExpense: HasuraOrderActions.getPromotionExpense,
}

export default connect(mapState, mapDispatch)(PromotionExpense)



// WEBPACK FOOTER //
// ./src/containers/reports/promotionExpense.js